import {Divider, useTheme} from '@mui/material';
import React, {Fragment, useState} from 'react';

import Icon from 'presentation/icons';
import {formatMasks} from 'presentation/utils';

import {CopySectionMaskEnum} from 'presentation/constants';
import {Snackbar} from '../Snackbar';
import {SectionContainer, ValueTypography} from './styles';
import {CopySectionProps} from './types';

function CopySection({
	value,
	mask = CopySectionMaskEnum.PHONE,
	snackbarMessage = 'Telefone copiado com sucesso.',
	callAction,
	highlightedIcons,
	customPadding,
	dataTagId,
	onBeforeCopy,
	testId,
}: CopySectionProps) {
	const theme = useTheme();
	const [showSnackbar, setShowSnackbar] = useState(false);

	const handleCloseSnackbar = () => {
		setShowSnackbar(false);
	};

	function copyToClipboard() {
		if (onBeforeCopy) {
			const shouldBlock = onBeforeCopy();
			if (shouldBlock) return;
		}
		if (value.length > 0 && !showSnackbar) {
			setShowSnackbar(true);
			navigator.clipboard.writeText(value);
		}
	}

	const withoutMask = mask === CopySectionMaskEnum.WITHOUT_MASK;
	const clear = mask === CopySectionMaskEnum.CLEAR;

	function handleCallAction() {
		window.location.href = `tel:${value}`;
	}

	if (!value) {
		return null;
	}

	return (
		<Fragment>
			<SectionContainer $customPadding={customPadding} data-testid={testId}>
				<ValueTypography $textOverflow={clear}>
					{!withoutMask ? formatMasks(mask, value) : value}
				</ValueTypography>
				<Icon
					onClick={copyToClipboard}
					name="content-copy-filled"
					color={
						highlightedIcons ? theme.palette.primary.main : theme.palette.action.active
					}
					data-tag-id={dataTagId?.copy}
				/>
				{callAction ? (
					<Fragment>
						<Divider orientation="vertical" flexItem />
						<Icon
							data-tag-id={dataTagId?.call}
							onClick={handleCallAction}
							name="phone-filled"
							color={theme.palette.primary.main}
						/>
					</Fragment>
				) : null}
			</SectionContainer>
			<Snackbar onClose={handleCloseSnackbar} message={snackbarMessage} open={showSnackbar} />
		</Fragment>
	);
}

export {CopySection};
